//请自行添加语言资源
const supplier = {

};
export default supplier



// WEBPACK FOOTER //
// ./src/page/md/supplier/lang/supplier.zh.js